import { ServiceData } from '../service';
import db from '../index';
import { DataOwner } from '../dataOwner';
import { entityServiceFactory } from '../entityServiceFactory';

export interface OrganizationsServiceData extends ServiceData {}
/** Data of the user: valid in every project. */
const { owner, add, clear, stopDownloading, get, reset, requestDownloadAgain } = entityServiceFactory<OrganizationsServiceData>(db, 'organizationsService', {
  owner: DataOwner.USER,
});

export { owner, add, clear, stopDownloading, get, reset, requestDownloadAgain };
